import {ChronologicalCommentsSort, useChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {isFeatureEnabled} from '@github-ui/feature-flags'

/** Always oldest first when the Activity tab is off. */
export function useIssueCommentsSort() {
  const [sort, setSort] = useChronologicalCommentsSort()
  const enabled = isFeatureEnabled('issue_viewer_activity_tab')

  return {sort: enabled ? sort : ChronologicalCommentsSort.OldestFirst, setSort, enabled}
}
